
const SunIco = ({fill}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99997 3.81564C8.25917 3.81564 8.46924 3.60556 8.46924 3.34637V1.46927C8.46924 1.21008 8.25917 1 7.99997 1C7.74077 1 7.5307 1.21008 7.5307 1.46927V3.34637C7.5307 3.60556 7.74077 3.81564 7.99997 3.81564Z"
        fill={fill}
      />
      <path
        d="M7.5307 12.6536V14.5307C7.5307 14.7899 7.74077 15 7.99997 15C8.25917 15 8.46924 14.7899 8.46924 14.5307V12.6536C8.46924 12.3944 8.25917 12.1843 7.99997 12.1843C7.74077 12.1843 7.5307 12.3944 7.5307 12.6536Z"
        fill={fill}
      />
      <path
        d="M14.5307 7.53074H12.6536C12.3944 7.53074 12.1844 7.74081 12.1844 8.00001C12.1844 8.2592 12.3944 8.46928 12.6536 8.46928H14.5307C14.7899 8.46928 15 8.2592 15 8.00001C15 7.74081 14.7899 7.53074 14.5307 7.53074Z"
        fill={fill}
      />
      <path
        d="M3.81563 8.00001C3.81563 7.74081 3.60556 7.53074 3.34636 7.53074H1.46927C1.21007 7.53074 0.999992 7.74081 0.999992 8.00001C0.999992 8.2592 1.21007 8.46928 1.46927 8.46928H3.34636C3.60556 8.46928 3.81563 8.2592 3.81563 8.00001Z"
        fill={fill}
      />
      <path
        d="M11.2907 5.17858C11.4109 5.17858 11.531 5.13274 11.6225 5.04108L12.9498 3.71381C13.1331 3.53064 13.1331 3.23343 12.9498 3.05026C12.7666 2.86693 12.4694 2.86693 12.2862 3.05026L10.9589 4.37752C10.7756 4.5607 10.7756 4.8579 10.9589 5.04108C11.0505 5.13274 11.1706 5.17858 11.2907 5.17858Z"
        fill={fill}
      />
      <path
        d="M4.37752 10.9589L3.05025 12.286C2.86692 12.4692 2.86692 12.7664 3.05025 12.9496C3.14176 13.0413 3.26205 13.0871 3.38203 13.0871C3.50201 13.0871 3.6223 13.0413 3.71381 12.9496L5.04107 11.6223C5.2244 11.4392 5.2244 11.142 5.04107 10.9588C4.85805 10.7756 4.56069 10.7756 4.37752 10.9589Z"
        fill={fill}
      />
      <path
        d="M10.9589 10.9589C10.7756 11.1421 10.7756 11.4393 10.9589 11.6225L12.2862 12.9497C12.3777 13.0414 12.498 13.0872 12.618 13.0872C12.738 13.0872 12.8583 13.0414 12.9498 12.9497C13.1331 12.7666 13.1331 12.4694 12.9498 12.2862L11.6225 10.9589C11.4393 10.7756 11.142 10.7756 10.9589 10.9589Z"
        fill={fill}
      />
      <path
        d="M4.37752 5.04108C4.46902 5.13274 4.58931 5.17858 4.70929 5.17858C4.82927 5.17858 4.94956 5.13274 5.04107 5.04108C5.2244 4.8579 5.2244 4.5607 5.04107 4.37752L3.71381 3.05026C3.53063 2.86693 3.23343 2.86693 3.05025 3.05026C2.86692 3.23343 2.86692 3.53064 3.05025 3.71381L4.37752 5.04108Z"
        fill={fill}
      />
      <path
        d="M7.98043 4.42178C6.00745 4.42178 4.40222 6.02701 4.40222 7.99999C4.40222 9.97298 6.00745 11.5782 7.98043 11.5782C9.95341 11.5782 11.5586 9.97298 11.5586 7.99999C11.5586 6.02701 9.95341 4.42178 7.98043 4.42178ZM7.98043 10.5605C6.56854 10.5605 5.41992 9.41188 5.41992 7.99999C5.41992 6.5881 6.56854 5.43948 7.98043 5.43948C9.39232 5.43948 10.5409 6.5881 10.5409 7.99999C10.5409 9.41188 9.39232 10.5605 7.98043 10.5605Z"
        fill={fill}
      />
    </svg>
  );
}

export default SunIco